import { render, staticRenderFns } from "./business-profile-create.vue?vue&type=template&id=de4ca334&"
import script from "./business-profile-create.vue?vue&type=script&lang=js&"
export * from "./business-profile-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports